import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Verify from './Verify'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import MdAssignmentLate from 'react-icons/lib/md/assignment-late'
import {Form, Field} from 'simple-react-form'
import Button from 'orionsoft-parts/lib/components/Button'


export default class Main extends React.Component {
  static propTypes = {
    client: PropTypes.object,
    onChange: PropTypes.func
  }

  getContainerStyle() {
    return {
      height: window.innerHeight
    }
  }

  state = {button: false}

  findCode() {
    if (!this.state.button) return
    return <Verify documentId={this.state.code} />
  }

  renderCode() {
    if (!this.state.button) return
    return (
      <div className={styles.verify}>
        <div className={styles.code}>Código ingresado: {this.state.code}</div>
        <Button
          primary
          onClick={() => {
            this.setState({button: false})
          }}
        >
          Nuevo Codigo
        </Button>
      </div>
    )
  }

  renderForm() {
    if (this.state.button) return
    return (
      <div className={styles.form}>
        <Form state={this.state} onChange={changes => this.setState(changes)}>
          <Field fieldName="code" label="code" type={Text} placeholder="Escribe el código aquí" />
        </Form>
        <div className={styles.button}>
          <Button primary disabled={!this.state.code} onClick={() => this.setState({button: true})}>
            Verificar
          </Button>
        </div>
      </div>
    )
  }

  render() {
    
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <h3 className={styles.title}>Verificación de documentos</h3>
              </div>
              <div className="col-xs-12 col-sm-8 end-md">
                <div className={styles.icon}>
                  <MdAssignmentLate size={20} />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <p className={styles.landingText}>
              Confirma la autenticidad de un documento suscrito en TuFirma ingresando su código
              verificador a continuación.
            </p>
            {this.renderForm()}
            {this.renderCode()}
          </div>
        </div>
        {this.findCode()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/DocumentVerify/Main/index.js